import { c as _c } from "react/compiler-runtime";
import { useFormContext } from "react-hook-form";
import { ListingType } from "../../../api/schema";
import { useTranslations } from "next-intl";
import { Building2, Home, KeyRound, Search } from "lucide-react";
import { useStepperFormContext } from "@/components/organisms/StepperForm/components/StepperFormProvider";
const options = [{
  value: ListingType.DEMAND,
  labelKey: "lookingForRoom",
  descriptionKey: "lookingForRoomDescription",
  icon: Search
}, {
  value: ListingType.SUPPLY,
  labelKey: "offeringRoom",
  descriptionKey: "offeringRoomDescription",
  icon: Home
}] as const;

// Not built yet — shown disabled with a "Soon" badge so the generic
// create-listing entries are honest that more than rooms is coming. Ordered so
// the 2-col grid reads find (left) / offer (right), same as the room pair.
const soonOptions = [{
  labelKey: "lookingToBuy",
  descriptionKey: "lookingToBuyDescription",
  icon: Search
}, {
  labelKey: "sellProperty",
  descriptionKey: "sellPropertyDescription",
  icon: Building2
}, {
  labelKey: "lookingToRent",
  descriptionKey: "lookingToRentDescription",
  icon: Search
}, {
  labelKey: "rentProperty",
  descriptionKey: "rentPropertyDescription",
  icon: KeyRound
}] as const;
export function useListingTypePrescreen() {
  const $ = _c(6);
  const t = useTranslations("modules.listings.addRoomListing.prescreen");
  const {
    setValue
  } = useFormContext();
  const {
    handleNextStep
  } = useStepperFormContext();
  let t0;
  if ($[0] !== handleNextStep || $[1] !== setValue) {
    t0 = value => {
      setValue("listingType", value, {
        shouldValidate: true
      });
      handleNextStep?.();
    };
    $[0] = handleNextStep;
    $[1] = setValue;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const selectListingType = t0;
  let t1;
  if ($[3] !== selectListingType || $[4] !== t) {
    t1 = {
      t,
      options,
      soonOptions,
      selectListingType
    };
    $[3] = selectListingType;
    $[4] = t;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}